import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatExpansionPanel } from '@angular/material';
import { CountdownComponent } from 'ngx-countdown';

@Component({
  selector: 'app-common-expiration-timeout-confirm-dialog',
  templateUrl: './common-expiration-timeout-confirm-dialog.component.html',
  styleUrls: ['./common-expiration-timeout-confirm-dialog.component.css']
})
export class CommonExpirationTimeoutConfirmDialogComponent implements OnInit {

  @ViewChild("freePanel") freezePanel! : MatExpansionPanel;
  @ViewChild('cd', { static: false }) countdown! : CountdownComponent;

  public time: number = 0;
  countdownConfig: any = { leftTime: 120, format: 'mm:ss' };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CommonExpirationTimeoutConfirmDialogComponent>,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    if (this.data.expirationTimeInSeconds) {
      this.time = this.data.expirationTimeInSeconds;
      this.countdownConfig.leftTime = this.data.expirationTimeInSeconds;
      this.cdr.detectChanges();
    }
  }

  onMainHeaderClose() {
    this.freezePanel.open();
  }
  closeDialog(value: boolean) {
    this.dialogRef.close(value);
  }

  onConfirmChange(value: boolean) {
    this.closeDialog(value);
  }

  timesUp(event: any) {
    if (event.action === 'done') {
      this.closeDialog(false); // Automatically close the dialog when time is up
    }
  }

}